import { gql } from '@provision/graphql-client';
import { CONVERSATION_TRIAGE_RUN_TIMELINE_FIELDS } from './conversation-triage-run.fragments';

export const GET_CONVERSATION_TRIAGE_RUNS_QUERY = gql`
  query GetConversationTriageRun($params: QueryParams)
  @entity(name: "ConversationTriageRun") {
    getConversationTriageRun(queryParams: $params) {
      records {
        ...ConversationTriageRunTimelineFields
      }
    }
  }
  ${CONVERSATION_TRIAGE_RUN_TIMELINE_FIELDS}
`;

export const RESOLVE_TRIAGE_ACTION_MUTATION = gql`
  mutation ResolveTriageAction($input: ResolveTriageActionInput!) {
    resolveTriageAction(input: $input) {
      id
      status
      visibility
      payload
      appliedAt
      appliedBy
      applyError
    }
  }
`;
